import {
	type ForwardRefExoticComponent,
	type ReactNode,
	type Ref,
	type RefAttributes,
	forwardRef,
} from 'react';

type ListItemProps = {
	/**
	 * The contents of the list item.
	 */
	children: ReactNode;
	/**
	 * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
	 */
	testId?: string;
	/**
	 * Bounded style overrides.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	xcss?: any;
};

function _ListItem({ children, testId, xcss }: ListItemProps, ref: Ref<HTMLDivElement>) {
	return (
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		<div role="listitem" ref={ref} className={xcss} data-testid={testId}>
			{children}
		</div>
	);
}

/**
 * __List item__
 *
 * A [list item](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/li) with visual styles removed.
 */
export const ListItem: ForwardRefExoticComponent<ListItemProps & RefAttributes<HTMLDivElement>> =
	forwardRef<HTMLDivElement, ListItemProps>(_ListItem);
